const React = require("react");
const { useInventorySource } = require("../context/InventorySourceContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingAllProducts = () => { const { t } = useInventorySource(); return h(ProductCollectionPage, { title: t("h_inventorySource_all_products", "InventorySource products"), description: t("h_inventorySource_all_products_desc", "Synchronize, filter and import products from your InventorySource suppliers.") }); };
module.exports = { DropshippingAllProducts };
